import { CircularProgress, Collapse, Typography } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

import { getTranslate } from '../../localization'
import {
  RateConnectionChannelFieldsType,
  RatePlanForRateConnection,
  RoomTypeForRateConnection
} from '../../types/rateConnection'
import PriceClassDistributionChannelRow from './PriceClassDistributionChannelRow'
import useStyles from './styles/PriceClassDistributionRatePlanRow.styles'

interface PriceClassDistributionRatePlanRowProps {
  ratePlanData: RatePlanForRateConnection
  openAll: boolean
  roomTypeIndex: number
  ratePlanIndex: number
  updatedRateConnectionList: RoomTypeForRateConnection[]
  setUpdatedRateConnectionList: React.Dispatch<
    React.SetStateAction<RoomTypeForRateConnection[]>
  >
  weekendIndexes: number[]
  range: 'TWO_WEEKS' | 'MONTH'
  selectedMenuFieldInChannelRow: RateConnectionChannelFieldsType
  setSelectedMenuFieldInChannelRow: React.Dispatch<
    React.SetStateAction<RateConnectionChannelFieldsType>
  >
}

const PriceClassDistributionRatePlanRow: React.FC<
  PriceClassDistributionRatePlanRowProps
> = ({
  ratePlanData,
  openAll,
  roomTypeIndex,
  ratePlanIndex,
  updatedRateConnectionList,
  setUpdatedRateConnectionList,
  weekendIndexes,
  range,
  selectedMenuFieldInChannelRow,
  setSelectedMenuFieldInChannelRow
}) => {
  const classes = useStyles()
  const [showChannels, setShowChannels] = useState(false)
  const PAGE_SIZE = 10
  const [numberOfVisibleChannels, setnumberOfVisibleChannels] =
    useState(PAGE_SIZE)

  useEffect(() => {
    if (openAll) {
      setShowChannels(true)
    } else {
      setShowChannels(false)
    }
  }, [openAll])

  useEffect(() => {
    setShowChannels(false)
  }, [range])

  return (
    <div>
      <div
        className={[
          classes.ratePlanRow,
          range === 'MONTH' && classes.ratePlanRowForMonth
        ].join(' ')}>
        <div className={classes.rowNameContainer}>
          <Typography variant="h4" className={classes.rowName}>
            {`${ratePlanData.name} (${ratePlanData.code})`}
          </Typography>{' '}
          <Typography
            variant="h6"
            className={classes.numberOfChannels}
            component="span"
            onClick={() => setShowChannels(!showChannels)}>
            {ratePlanData.channels.length} {getTranslate('Channels')}
          </Typography>
          <div className={classes.channelLoading}>
            <ArrowRightIcon
              className={[
                classes.ratePlanArrowRight,
                showChannels ? classes.ratePlanArrowDown : ''
              ].join(' ')}
            />
          </div>
        </div>
        <div />
        {Array(range === 'TWO_WEEKS' ? 14 : 30)
          .fill(' ')
          .map((_, index) => (
            <div
              key={index}
              className={[
                classes.emptyBox,
                weekendIndexes.includes(index % 7)
                  ? classes.weekendDayContainer
                  : ''
              ].join(' ')}
            />
          ))}
      </div>
      <Collapse in={showChannels}>
        <div>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              setTimeout(() => {
                setnumberOfVisibleChannels(numberOfVisibleChannels + PAGE_SIZE)
              }, 500)
            }}
            hasMore={
              ratePlanData &&
              numberOfVisibleChannels < ratePlanData.channels.length - 1
            }
            loader={
              <div key={0} className={classes.loadingContainer}>
                <CircularProgress size={32} />
              </div>
            }
            useWindow={true}>
            {ratePlanData.channels
              .slice(0, numberOfVisibleChannels)
              .map((item, channelIndex) => (
                <PriceClassDistributionChannelRow
                  key={channelIndex}
                  channelData={item}
                  openAll={openAll}
                  roomTypeIndex={roomTypeIndex}
                  ratePlanIndex={ratePlanIndex}
                  channelIndex={channelIndex}
                  updatedRateConnectionList={updatedRateConnectionList}
                  setUpdatedRateConnectionList={setUpdatedRateConnectionList}
                  weekendIndexes={weekendIndexes}
                  range={range}
                  selectedMenuFieldInChannelRow={selectedMenuFieldInChannelRow}
                  setSelectedMenuFieldInChannelRow={
                    setSelectedMenuFieldInChannelRow
                  }
                />
              ))}
          </InfiniteScroll>
        </div>
      </Collapse>
    </div>
  )
}

export default PriceClassDistributionRatePlanRow
